module.exports = __webpack_public_path__ + "img/p24.6761b1de.png";